module.exports = __webpack_public_path__ + "img/bell_tower.4e86fcf7.svg";